import { api } from './api';

export interface DailyPostsPoint {
  day: string;
  total: number;
}

export interface DailyPostsStats {
  days: DailyPostsPoint[];
  total_in_window: number;
}

export interface OpenAiDailyPoint {
  day: string;
  cost_usd: number;
  input_tokens: number;
  output_tokens: number;
  calls: number;
}

export interface OpenAiCostStats {
  since: string;
  until: string;
  total_cost_usd: number;
  total_input_tokens: number;
  total_output_tokens: number;
  total_calls: number;
  by_day: OpenAiDailyPoint[];
  by_template: Record<string, number>;
}

export const statsApi = {
  postsDaily: (days = 14, categories?: number[]) => {
    const qs = new URLSearchParams({ days: String(days) });
    if (categories?.length) qs.set('categories', categories.join(','));
    // Mesma regra de `articlesApi.list`: sem site WordPress no escopo, a
    // estatistica responde 404 — e isso e uma conta que ainda nao conectou o
    // site, nao um incidente. O Dashboard e a PRIMEIRA tela depois do login;
    // abrir o produto e levar um alarme vermelho por nao ter configurado nada
    // ainda e o pior primeiro segundo possivel.
    return api.get<DailyPostsStats>(`/posts/stats/daily?${qs}`, { esperados: [404] });
  },
  openaiCost: (days = 30) =>
    api.get<OpenAiCostStats>(`/audit/stats/openai?days=${days}`),
};
